import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'error' | 'info';

export interface ToastMessage {
  id: number;
  type: ToastType;
  text: string;
  timeoutMs?: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly messagesSig = signal<ToastMessage[]>([]);
  private nextId = 1;

  public messages() {
    return this.messagesSig();
  }

  public success(text: string, timeoutMs: number = 3000): void {
    this.push('success', text, timeoutMs);
  }

  public error(text: string, timeoutMs: number = 4000): void {
    this.push('error', text, timeoutMs);
  }

  public info(text: string, timeoutMs: number = 3000): void {
    this.push('info', text, timeoutMs);
  }

  public remove(id: number): void {
    this.messagesSig.update(list => list.filter(m => m.id !== id));
  }

  private push(type: ToastType, text: string, timeoutMs?: number): void {
    const id = this.nextId++;
    const message: ToastMessage = { id, type, text, timeoutMs };
    this.messagesSig.update(list => [...list, message]);
    if (timeoutMs && timeoutMs > 0) {
      window.setTimeout(() => this.remove(id), timeoutMs);
    }
  }
}


